import { Flex, HStack, ListItem, StackDivider, UnorderedList, VStack } from '@chakra-ui/react'
import { GrandText } from 'ui'
import Image from 'next/image'
import klarnaLogo from '#/src/images/Klarna_Logo.png'
import sveaLogoImg from '#/src/images/svea_logo.png'
import appConfig from '#/src/appConfig'

const CustomProductDelivery = () => {
  const PaymentProviderInfo = () => {
    switch (appConfig.paymentProviderConfig?.providerName ?? 'KLARNA') {
      case 'KLARNA':
      case 'NEXI':
        return (
          <VStack alignItems="flex-start" flex={1} p={2}>
            <GrandText>Betala efter leverans.</GrandText>
            <Flex justifyContent="center" w="80%">
              <Image alt="Klarna" src={klarnaLogo} title="klarna" />
            </Flex>
          </VStack>
        )
      case 'SVEA':
        return (
          <VStack alignItems="flex-start" flex={1} p={2}>
            <Image alt="Svea payment methods" src={sveaLogoImg} />
          </VStack>
        )
      // todo: add LEDYER info
      case 'LEDYER':
        return <>LEDYER info</>
    }
  }

  return (
    <VStack>
      <HStack divider={<StackDivider />}>
        <PaymentProviderInfo />

        <UnorderedList flex={1} fontSize="xs" p={2}>
          <ListItem>50 års erfarenhet</ListItem>
          <ListItem>Nordens största showroom</ListItem>
          <ListItem>Personlig service</ListItem>
        </UnorderedList>
      </HStack>
    </VStack>
  )
}

export default CustomProductDelivery
